import { create } from "zustand";
import { persist } from "zustand/middleware";

const defaultValues = {
  SCStatus: "",
  gatepassCategory: "cargo",
  passportNumber: "",
  emiratesIdNumber: "",
  fullName: "",
  sponsorCompany: "",
  expectedEntryDate: "",
  port: "",
  gate: "",
  FOTTEntry: true,
};

type CargoGatepassFormData = typeof defaultValues;

interface CargoGatepassFormState extends CargoGatepassFormData {
  setField<K extends keyof CargoGatepassFormData>(key: K, val: CargoGatepassFormData[K]): void;
  setAll(data: Partial<CargoGatepassFormData>): void;
  resetForm(): void;
}

export const useCargoGatepassFormStore = create<CargoGatepassFormState>()(
  persist(
    (set) => ({
      ...defaultValues,
      setField: <K extends keyof CargoGatepassFormData>(key: K, val: CargoGatepassFormData[K]) =>
        set((state) => ({ ...state, [key]: val })),
      setAll: (data: Partial<CargoGatepassFormData>) => set((state) => ({ ...state, ...data })),
      resetForm: () => set(() => ({ ...defaultValues })),
    }),
    { name: "cargo-gatepass-form" },
  ),
);
